import AskIQIcon from 'assets/IQLogos/iq_text_logo.svg?react';

import Text from 'lib/common/components/Text';

import styles from './ask-iq-heading.module.scss';

export function AskIQHeading() {
  return (
    <div className={styles['ask-iq-heading']}>
      <Text type="heading3" className={styles['ask-iq-heading__text']}>
        Ask
      </Text>
      <AskIQIcon className={styles['ask-iq-heading__icon']} />
    </div>
  );
}
